export default __webpack_public_path__ + "static/yellow-big-star-eaf511a36520fcf6ead6b7354c8342b6.png";